import NotesPanelHeader from './NotesPanelHeader';

export default NotesPanelHeader;